'use strict';

angular.module('amexReconciliationApp')
  .component('transactionFilter', {
    templateUrl: 'scripts/views/components/transaction-filter.html',
    controller: function (TransactionFilterModel, AnalyticsService) {

      var self = this;
      var firstTimeFiltering = true;

      self.filter = TransactionFilterModel.filter;
      self.filterByExceptionFlag = TransactionFilterModel.filterByExceptionFlag();

      self.applyFilterByExceptionFlag = function() {
        TransactionFilterModel.filterByExceptionFlag(self.filterByExceptionFlag);
      };

      self.clearSearch = function () {
        TransactionFilterModel.filter('');
      };

      self.canDeleteSearch = function () {
        return !_.isEmpty(TransactionFilterModel.filter());
      };

      self.logEvent = function () {
        if(firstTimeFiltering) {
          AnalyticsService.logTransactionFiltering();
          firstTimeFiltering = false;
        }
      };

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionFilter.js
// module id = 486
// module chunks = 0